import { reportsConstants } from 'locale/team'
import EditProfileCard from '../../../../components/forms/screens/TeamMemberEditFormV2/EditProfileCard'
import { fmtDate } from '../../utils/dateUtils'
import ProfileFieldRow, { ProfileFieldGrid } from './ProfileFieldRow'

type Props = { profile: Record<string, any>; t: (k: string) => string }

const EmploymentViewCard = ({ profile, t }: Props) => (
  <EditProfileCard
    title={t(reportsConstants.PROFILE_VIEW_CARD_EMPLOYMENT)}
    testId="profile-view-employment"
    showTitleDivider
    fullWidth
  >
    <ProfileFieldGrid>
      <ProfileFieldRow
        label={t(reportsConstants.PROFILE_VIEW_START_DATE)}
        value={fmtDate(profile.startDate)}
      />
      <ProfileFieldRow
        label={t(reportsConstants.PROFILE_VIEW_END_DATE)}
        value={fmtDate(profile.endDate)}
      />
    </ProfileFieldGrid>
  </EditProfileCard>
)

export default EmploymentViewCard
